/**
 * SEO configuration - single source of truth for base URL and site metadata.
 * Used across PageMeta, structured data, and sitemap generation.
 */
export const SEO_CONFIG = {
  /** Base URL - always use absolute URLs for meta tags and structured data */
  baseUrl: (import.meta.env.VITE_APP_URL || 'https://fullbook.fr').replace(/\/$/, ''),
  siteName: 'FullBook',
  defaultTitle: 'FullBook – Réservez vos activités indoor en Île-de-France',
  defaultDescription:
    "Réservez en ligne vos activités indoor en Île-de-France : bowling, karting, escape game, laser game, padel et plus encore. Paiement sécurisé.",
} as const;

/** Max length for meta descriptions (Google truncates around 155-160 chars) */
export const META_DESCRIPTION_MAX_LENGTH = 155;

/** Safely truncate text for meta description */
export function truncateForMeta(text: string, maxLen = META_DESCRIPTION_MAX_LENGTH): string {
  if (!text || text.length <= maxLen) return text;
  return text.slice(0, maxLen - 1).trimEnd() + '\u2026';
}

/** Build absolute URL from path */
export function absoluteUrl(path: string): string {
  const base = SEO_CONFIG.baseUrl;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
